module.exports = __webpack_public_path__ + "img/bg.e558dd7b.svg";